import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import CompanyDetail from "@/pages/CompanyDetail";
import LeadActivity from "@/pages/LeadActivity";
import ScoringAdmin from "@/pages/ScoringAdmin";
import Connectors from "@/pages/Connectors";
import Retention from "@/pages/Retention";
import AgentControlCentre from "@/pages/AgentControlCentre";
import SettingsPage from "@/pages/Settings";

const withLayout = (el: React.ReactNode, roles?: string[]) => (
  <ProtectedRoute roles={roles}>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={withLayout(<Dashboard />)} />
          <Route path="/companies" element={withLayout(<Companies />)} />
          <Route path="/companies/:id" element={withLayout(<CompanyDetail />)} />
          <Route path="/activity" element={withLayout(<LeadActivity />)} />
          <Route path="/scoring" element={withLayout(<ScoringAdmin />, ["admin"])} />
          <Route path="/connectors" element={withLayout(<Connectors />, ["admin"])} />
          <Route path="/retention" element={withLayout(<Retention />, ["admin"])} />
          <Route path="/agents" element={withLayout(<AgentControlCentre />)} />
          <Route path="/settings" element={withLayout(<SettingsPage />)} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
